// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_1eC","cls2":"HeroWorkCardHeader-cls2_kPo HeroWorkCardHeader-cls1_1eC"};